import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { projectExpense }: Boundaries["editProjectExpense"]["request"],
): State {
  const index = state.findIndex(
    (res) => res.projectExpense.uuid === projectExpense.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { projectExpense, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { projectExpense, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { projectExpense }: Boundaries["editProjectExpense"]["success"],
): State {
  return state.map((res) =>
    res.projectExpense.uuid === projectExpense.uuid
      ? { projectExpense, request: setRequestStateToSuccess() }
      : res,
  );
}

function handleFailure(
  state: State,
  { projectExpense }: Boundaries["editProjectExpense"]["failure"],
): State {
  return state.map((res) =>
    res.projectExpense.uuid === projectExpense.uuid
      ? { projectExpense, request: setRequestStateToFailure() }
      : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editProjectExpenseRequested]: handleRequest,
    [events.editProjectExpenseSucceeded]: handleSuccess,
    [events.editProjectExpenseFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
